// src/utils/messengerHelpers.ts
export const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const getLastName = (full?: string | null) => {
  if (!full) return null;
  const parts = full.trim().split(/\s+/);
  if (parts.length < 2) return null;
  const last = parts[parts.length - 1];
  if (last.length === 1) return null; // ignore initials
  return last;
};

// tiny starter list — expand if needed
export const PROFANITY_WORDS = [
  'fuck','shit','bitch','asshole','dick','cunt','slut','whore','bastard','bollocks','wanker'
];

export const PROFANITY_RE = new RegExp(`\\b(${PROFANITY_WORDS.map(escapeRegExp).join('|')})\\b`, 'i');
export const EMAIL_RE = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i;

// Very strict: blocks any digit. If you want to allow “5 pm”, consider a looser rule (see note below).


const PHONE_CANDIDATE_RE =
  /(?:\+?\s*)?(?:\(?\d{1,4}\)?[\s.-]*)?(?:\d[\s().-]*){6,}\d(?:\s*(?:#|x|ext\.?|extension)\s*\d{1,6})?/gi;

export const containsPhoneNumber = (text: string) => {
  let m: RegExpExecArray | null;
  const re = new RegExp(PHONE_CANDIDATE_RE.source, 'gi');
  while ((m = re.exec(text))) {
    // ignore any extension when counting digits
    const [beforeExt] = m[0].split(/(?:#|x|ext\.?|extension)\s*\d{1,6}/i);
    const digitsOnly = beforeExt.replace(/\D/g, '');

    // General rule: 10–15 digits is phone-like (area/country code included)
    if (digitsOnly.length >= 10 && digitsOnly.length <= 15) return true;

    // Slightly looser if explicitly international (+ prefix): 9–15 digits
    if (/^\s*\+/.test(m[0]) && digitsOnly.length >= 9 && digitsOnly.length <= 15) return true;
  }
  return false;
};
// Helper: unique, lowercased strings (null/undefined filtered out)
const uniqueLower = (arr: Array<string | null | undefined>) => {
  const lowered: string[] = [];
  for (let i = 0; i < arr.length; i++) {
    const v = arr[i];
    if (v) lowered.push(v.toLowerCase());
  }
  // Avoid Set iteration so we don’t need ES2015 target
  const seen: Record<string, true> = {};
  const out: string[] = [];
  for (let i = 0; i < lowered.length; i++) {
    const val = lowered[i];
    if (!seen[val]) {
      seen[val] = true;
      out.push(val);
    }
  }
  return out;
};

export const validateMessage = (
  content: string,
  context: {
    meName?: string | null;
    otherName?: string | null;
    parentName?: string | null;
    tutorName?: string | null;
  }
) => {
  const reasons: string[] = [];
  const text = content || '';

  if (EMAIL_RE.test(text)) reasons.push('Please remove email addresses.');
  if (containsPhoneNumber(text)) reasons.push('Please remove any phone numbers.');
  if (PROFANITY_RE.test(text)) reasons.push('Please remove obscene language.');

  // block surnames for both parties (safer)
  const candidates = uniqueLower([
    getLastName(context.meName),
    getLastName(context.otherName),
    getLastName(context.parentName),
    getLastName(context.tutorName),
  ]);

  for (let i = 0; i < candidates.length; i++) {
    const ln = candidates[i];
    const re = new RegExp(`\\b${escapeRegExp(ln)}\\b`, 'i');
    if (re.test(text)) {
      reasons.push(`Please remove the surname “${ln}”.`);
      break;
    }
  }

  return reasons;
};

